import { Trans } from '@lingui/react/macro';
import { FAQ, FAQLine } from 'src/components';
import { SUPPORT_URL } from 'src/utils/urls/supportUrls';

export const PaymentHistoryFAQ = () => {
  return (
    <FAQ>
      <FAQLine
        text={<Trans>What different payment options do I have?</Trans>}
        target={SUPPORT_URL.ARTICLES.PAYMENT_OPTIONS_FOR_CONNECT}
      />

      <FAQLine
        text={<Trans>Why was my payment method rejected?</Trans>}
        target={SUPPORT_URL.ARTICLES.REJECTED_PAYMENT}
      />

      <FAQLine
        text={<Trans>When and how often will I be charged?</Trans>}
        target={SUPPORT_URL.ARTICLES.CONNECT_BILLING_DATE}
      />

      <FAQLine
        text={<Trans>Why was my billing different than I expected?</Trans>}
        target={SUPPORT_URL.ARTICLES.UNEXPECTED_SUBSCRIPTION_CHARGES}
      />
    </FAQ>
  );
};
